// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_q5-5";
export var filledCircle = "_q5-4";
export var historyEntry = "_q5-3";
export var messageSideLeft = "_q5-1";
export var messageSideRight = "_q5-2";
export var orderTrackingCarouselWrapper = "_q5-6";
export var orderTrackingInfoContainer = "_q5-0";